//#region Dependencias
import config from "../config";
import React, { Component } from "react";
import "../css/dataTables.css";
import $ from "jquery";
import moment from "moment";
import StandardSelectModal from "./StandardSelectModal";
import SuggestionList from "./SuggestionList";
import { MRPAssistant } from "./NewOrder";
import WarningModal from "./WarningModal";
import { MRPAssistanceItems, MRPPeggingModal } from '../components';
import { ApiClient } from "../libs/apiClient";
import { SERVICE_RESPONSE, decodeText } from "../libs/utils/Const";
import jsPDF from "jspdf";
const apiClient = ApiClient.getInstance();
//#endregion

//#region Variables globales
const docTypeRecommendation = (type) => {
    const orderTypeOptions = [{ key: 'P', value: "Pedido" }, { key: 'Q', value: "Oferta de compra" }, { key: 'R', value: "Solicitud de compra" }, { key: 'T', value: "Solicitud de traslado" }, { key: 'W', value: "Orden de fabricación" }]
    const ordrType = orderTypeOptions.find(typeOption => typeOption.key === type)
    if (ordrType) {
        return ordrType.value
    } else {
        return ''
    }
}

//#endregion

class MRPAssistantModal extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            editMode: false,
            searchItem: "",
            showItemsModal: false,

            updateLine: -1,
            predictionsAction: () => { },
            showPredictionsList: false,
            predictions: [],

            showWarningModal: false,
            warningModel: {
                size: "modal-md",
                cancel: () => { },
            },

            recoveryModel: new MRPAssistant(),
            mountSelectItemsModal: false,
            searchItemModel: {
                from: '',
                to: '',
                itmGrp: '',
            },
            ListItemsGroup: [],
            CheckSelectAllItems: "Y",
            showForecastModal: false,
            saveRecommendations: false,
            recommendations: [],
            informe: {},
            auxRecommendations: [],
            auxInforme: {},
            showResultDetails: [],

            showPeggingModal: false,
            peggingFilters: {
                ItemCode: "",
                ItemName: "",
                StartDate: "",
                EndDate: "",
            },
            peggingDocuments: [],
            documents: [],
            groupRecomendations: [],
            totalDocs: 0,
            currDoc: 0,

        };
    }

    componentDidMount = async () => {
        const bodyModal = document.getElementById('bodyModal');
        if (bodyModal) { bodyModal.addEventListener('scroll', () => { this.setState({ showPredictionsList: false, predictions: [] }) }); }
    }

    editMode = async () => {
        const { model, updateModel } = this.props;
        const recoveryModel = JSON.parse(JSON.stringify(model));
        const auxRecom = this.state.recommendations.slice()
        const informe = { ...this.state.informe }
        await this.setState({
            editMode: true,
            recoveryModel,
            auxRecommendations: auxRecom,
            auxInforme: informe,
            recommendations: [],
            informe: {},

        });

        let auxModel = Object.assign({}, model);
        auxModel.editMode = true;
        await updateModel(auxModel);
    }

    cancelEditMode = async () => {
        const { updateModel } = this.props;
        const { warningModel, recoveryModel } = this.state;
        warningModel.accept = (async () => {
            await updateModel(recoveryModel);
            await this.setState({
                editMode: false,
                recoveryModel: new MRPAssistant(),
                recommendations: this.state.auxRecommendations,
                informe: this.state.auxInforme
            });
        });
        warningModel.message = "¿Desea descartar todos los cambios?";
        warningModel.acceptMsg = "Descartar";
        warningModel.cancelMsg = "Seguir editando";

        await this.setState({
            warningModel,
            showWarningModal: true,
        });
        $("#warningModal").modal("show");

        $("#warningModal").on("hidden.bs.modal", async () => {
            warningModel.accept = null;
            warningModel.message = null;
            warningModel.acceptMsg = null;
            warningModel.cancelMsg = null;
            await this.setState({
                showWarningModal: false,
                warningModel,
            });
        });


    }

    closeModal = () => {
        this.setState({
            recommendations: [],
            informe: {},
            auxRecommendations: [],
            auxInforme: {},
            currDoc: 0,
            totalDocs: 0,
            groupRecomendations: []
        })
        $("#mrpAssistantModal").modal("hide");
    };

    OpenSelectItemsModal = async () => {
        const { showAlert } = this.props
        await this.ChangeAnyPropInstate("mountSelectItemsModal", true);
        $("#MRPAssistanceItemsModal").modal("show");
        const GroupsItemData = await apiClient.getGroupsItemData();

        if (GroupsItemData.status !== 1) {
            showAlert({ type: "error", message: `${GroupsItemData.message}` });
            return
        }
        await this.ChangeAnyPropInstate("ListItemsGroup", GroupsItemData.data?.GrupoArticulo ?? []);
    }

    ChangeAnyPropInstate = (prop = "", value = "") => {
        this.setState({
            [prop]: value
        })
    }

    CloseActionsItemsSearch = async () => {
        $("#MRPAssistanceItemsModal").modal("hide");
        await this.setState({
            mountSelectItemsModal: false,
            searchItemModel: {
                from: '',
                to: '',
                itmGrp: '',
            },
        })
    }

    openForecastModal = async () => {
        await this.setState({ showForecastModal: true });
        $("#selectForecastModal").modal("show");
        $("#selectForecastModal").on("hidden.bs.modal", async () => { await this.setState({ showForecastModal: false }); });
    }

    resultDetails = (index = 0) => {
        let showResultDetails = this.state.showResultDetails.slice();
        showResultDetails[index] = !showResultDetails[index];
        this.setState({ showResultDetails });
    }
    //#endregion

    //#region Update Model
    updateModel = async (filed = "", value = "") => {
        const { model, updateModel } = this.props;
        let auxModel = Object.assign({}, model);
        auxModel[filed] = value;
        await updateModel(auxModel);
    }

    showLineDetails = async (index) => {
        const { model, updateModel } = this.props;
        let auxModel = Object.assign({}, model);
        auxModel.Lines[index].Details = !auxModel.Lines[index].Details;
        await updateModel(auxModel);
    }

    DeleteAllItems = () => {
        let auxModel = this.props.model;
        auxModel.ItmArray = [];
        this.props.updateModel(auxModel);
    }

    DeleteItemLine = (index) => {
        let auxModel = this.props.model;
        auxModel.ItmArray.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        this.props.updateModel(auxModel);
    }

    ChangeItemsType = async (value) => {
        if (value === "Y") { await this.DeleteAllItems(); }
        this.updateModel("AllItems", value);
    }

    //#region Scenario Values
    changeStandardField = async (field, value) => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        modelAux[field] = value;
        await updateModel(modelAux);
    }

    changeDateField = async (type = 1, value = "", input) => {
        const { updateModel, model, showAlert } = this.props;
        if (!moment(value).isValid()) {
            input.focus();
            return showAlert({ type: "warning", message: "Ingrese una fecha valida" });
        }
        let modelAux = Object.assign({}, model);
        const viewType = model.GrpPeriods || "M";
        const dateParams = value.split('-');
        let date = new Date(dateParams[0], dateParams[1] - 1, dateParams[2]);

        if (type === 1) {
            const endDateParams = modelAux.EndDate.split('-');
            let endDate = new Date(endDateParams[0], endDateParams[1] - 1, endDateParams[2]);
            if (date > endDate) {
                input.focus();
                return showAlert({ type: "warning", message: "La fecha de inicio no puede ser mayor a la fecha final" });
            }

            if (viewType === "M") { date.setDate(1); } // Ajustar el dia al primero del mes
            else if (viewType === "W") { while (date.getDay() !== 1) { date.setDate(date.getDate() - 1); } } // Ajustar el dia al Lunes de esa semana

            modelAux.StartDate = moment(date).format("YYYY-MM-DD");
            if (modelAux.StartDate !== modelAux.PrevStartDate) {
                modelAux.PrevStartDate = moment(date).format("YYYY-MM-DD");
            }
        } else {
            const startDateParams = modelAux.StartDate.split('-');
            let startDate = new Date(startDateParams[0], startDateParams[1] - 1, startDateParams[2]);
            if (startDate > date) {
                input.focus();
                return showAlert({ type: "warning", message: "La fecha final no puede ser menor a la fecha de inicio" });
            }

            if (viewType === "M") {
                date = new Date(date.getFullYear(), date.getMonth() + 1, 1); // Ajustar el dia al primero del siguiente mes
                date.setDate(date.getDate() - 1); // Regresar un día para tener el ultimo del
            }
            else if (viewType === "W") { while (date.getDay() !== 0) { date.setDate(date.getDate() + 1); } } // Ajustar el dia al Lunes de esa semana

            modelAux.EndDate = moment(date).format("YYYY-MM-DD");
            if (modelAux.EndDate !== modelAux.PrevEndDate) {
                modelAux.PrevEndDate = moment(date).format("YYYY-MM-DD");
            }
        }

        const startDate = moment(modelAux.StartDate);
        const endDate = moment(modelAux.EndDate);

        modelAux.HorizonLength = endDate.diff(startDate, viewType === "M" ? "months" : viewType === "W" ? "weeks" : "days") + 1;
        await updateModel(modelAux);
    }

    changeTypeView = async (value) => {
        const { updateModel, model } = this.props;

        const startDateParams = model.StartDate.split('-');
        const endDateParams = model.EndDate.split('-');
        let startDate = new Date(startDateParams[0], startDateParams[1] - 1, startDateParams[2]);
        let endDate = new Date(endDateParams[0], endDateParams[1] - 1, endDateParams[2]);

        let modelAux = Object.assign({}, model);

        if (value === "M") {
            startDate.setDate(1); // Ajustar el dia al primero del mes
            endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1); // Ajustar el dia al primero del siguiente mes
            endDate.setDate(endDate.getDate() - 1); // Regresar un día para tener el ultimo del mes
        } else if (value === "W") {
            while (startDate.getDay() !== 1) { startDate.setDate(startDate.getDate() - 1); } // Ajustar el dia al Lunes de esa semana
            while (endDate.getDay() !== 0) { endDate.setDate(endDate.getDate() + 1); } // Ajustar el dia al Domingo de esa semana
        }

        modelAux.GrpPeriods = value;
        modelAux.StartDate = moment(startDate).format("YYYY-MM-DD");
        modelAux.EndDate = moment(endDate).format("YYYY-MM-DD");

        modelAux.HorizonLength = moment(endDate).diff(moment(startDate), value === "M" ? "months" : value === "W" ? "weeks" : "days") + 1;
        updateModel(modelAux);
    }

    changeHorizon = async (value = "") => {
        value = (value || "").trim();
        if (isNaN(value)) return;
        if (Number(value) % 1 !== 0) return;

        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        modelAux.HorizonLength = Number(value);

        const period = modelAux.GrpPeriods;
        let endDate = moment(modelAux.StartDate);
        endDate = endDate.add(Number(value), period === "M" ? "months" : period === "W" ? "weeks" : "days");
        endDate = endDate.add(-1, "days");
        modelAux.EndDate = endDate.format("YYYY-MM-DD");

        await updateModel(modelAux);
    }
    changeCheckedV2 = async (field, value) => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        modelAux[field] = value === 'Y' ? "N" : "Y";
        await updateModel(modelAux);
    }

    changeChecked = async (field, value = true) => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        modelAux[field] = value ? "Y" : "N";
        await updateModel(modelAux);
    }

    ChargeItemsInTabAsMayBeFilters = async () => {
        const { showAlert, enableSpinner } = this.props
        const { searchItemModel } = this.state

        enableSpinner(true);
        const responseApi = await apiClient.chargeItemsByFilters(searchItemModel);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        if (!responseApi.data.length) {
            return showAlert({ type: "info", message: `No hay informacion con esos parametros` });
        }

        this.updateModel("ItmArray", responseApi.data ?? [])
        this.CloseActionsItemsSearch();
    }

    ChangeSelectLineItem = (index) => {
        const { model } = this.props
        let auxItems = model.ItmArray;
        auxItems[index].Selected = auxItems[index].Selected === "Y" ? 'N' : "Y";
        this.updateModel("ItmArray", auxItems)
    }

    ChangeAllItemsSelected = () => {
        const { model } = this.props
        if (model.ItmArray.length > 0) {
            const auxCheckSelectAllItems = this.state.CheckSelectAllItems === "Y" ? 'N' : "Y"
            const auxArray = model.ItmArray.map(obj => {
                obj.Selected = auxCheckSelectAllItems;
                return obj;
            });
            this.updateModel("ItmArray", auxArray)
            this.ChangeAnyPropInstate("CheckSelectAllItems", auxCheckSelectAllItems);
        }
    }

    changeWhsField = async (index, field, value = true) => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        modelAux.WhsArray[index][field] = value ? "Y" : "N";
        if (!value) { modelAux.WhsChecks[field] = false; }
        else {
            modelAux.WhsChecks[field] = true;
            for (const whs of modelAux.WhsArray) {
                if (whs[field] === "N") {
                    modelAux.WhsChecks[field] = false;
                    break;
                }
            }
        }
        await updateModel(modelAux);
    }

    changeAllWhsField = async (field, value = true) => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);

        modelAux.WhsChecks[field] = value;
        for (const whs of modelAux.WhsArray) { whs[field] = value ? "Y" : "N"; }

        await updateModel(modelAux);
    }

    selectForecast = async (forecastArray = []) => {
        const { updateModel, model, forecastList } = this.props;
        let modelAux = Object.assign({}, model);
        if (!forecastArray.length) { modelAux.FCTAbs = ""; }
        else {
            if (forecastArray.length === 1) { modelAux.FCTAbs = forecastArray[0]; }
            else {
                modelAux.FCTAbs = -999;
                modelAux.Documents = [];
                for (const forecast of forecastList) {
                    modelAux.Documents.push({
                        DocType: 198,
                        DocEntry: forecast.AbsID,
                        Selected: forecastArray.find(AbsID => AbsID === forecast.AbsID) ? "Y" : "N",
                        DocSubType: "",
                    });
                }
            }
        }
        await updateModel(modelAux);
    }
    //#endregion
    //#endregion

    //#region PeggingInformation
    getPeggingInformation = async (ItemCode, date, StockType = "R") => {
        const { model, enableSpinner, showAlert } = this.props;
        let startDate = moment(date, "YYYY-MM");
        let endDate = moment(date, "YYYY-MM");

        if (model.GrpPeriods === "M") {
            endDate = moment(startDate).add(model.PeriodsLen, "months").add(-1, "days");
        }

        enableSpinner(true);
        const response = await apiClient.getPeggingInformation({
            AbsEntry: model.DocEntry,
            ItemCode,
            StartDate: startDate.format("YYYY-MM-DD"),
            EndDate: endDate.format("YYYY-MM-DD"),
        })
        enableSpinner(false);
        if (!response.status) { return showAlert({ type: "error", message: response.message || "Ocurrió un error al consultar la información, vuelva a intentaro" }); }
        if (!response.data.length) { return showAlert({ type: "info", message: response.message || "No hay información para mostrar" }); }
        const filteredData = response.data.filter(doc => doc.StockType === StockType);
        if (!filteredData.length) { return showAlert({ type: "info", message: response.message || "No hay información para mostrar" }); }

        await this.setState({
            showPeggingModal: true,
            peggingFilters: {
                ItemCode,
                ItemName: filteredData[0].ItemName,
                StartDate: startDate.format("DD/MM/YYYY"),
                EndDate: endDate.format("DD/MM/YYYY"),
            },
            peggingDocuments: filteredData,
        });

        $("#PeggingInformationModal").modal("show");
        $("#PeggingInformationModal").on("hidden.bs.modal", async () => {
            await this.setState({
                showPeggingModal: false,
                peggingFilters: {
                    ItemCode: "",
                    ItemName: "",
                    StartDate: "",
                    EndDate: "",
                },
                peggingDocuments: [],
            });
        });
    }
    //#endregion

    //#region Render
    renderDetails() {
        const { action, model } = this.props;
        const { editMode } = this.state;

        return (
            <>
                <h4> Detalles del escenario </h4>
                <p className="mb-3"> Defina el horizonte de planificación que desea ver en el informe MRP. </p>
                <div className="row pr-0">
                    {/* Primera Columna */}
                    <div className="col-12 col-lg-6">
                        {action === 1 &&
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold"> Nombre Escenario </span>
                                </div>
                                <input
                                    id="inputForecastCode"
                                    className="form-control"
                                    type="text"
                                    disabled={action === 2 && !editMode}
                                    value={model.MsnCode}
                                    maxLength={30}
                                    onChange={({ target: { value } }) => this.changeStandardField("MsnCode", value)} />
                            </div>
                        }
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Descripción </span>
                            </div>
                            <input
                                id="inputForecastCode"
                                className="form-control"
                                type="text"
                                disabled={action === 2 && !editMode}
                                value={model.Descr}
                                maxLength={100}
                                onChange={({ target: { value } }) => this.changeStandardField("Descr", value)} />
                        </div>
                    </div>
                </div>
                <div className="row pr-0 mt-4">
                    {/* Primera Columna */}
                    <div className="col-12 col-lg-6">
                        <h5 className="mb-3"> Horizonte de planificación </h5>

                        {/* Fecha de inicio - StartDate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Fecha de inicio </span>
                            </div>
                            <input
                                id="inputStartDate"
                                className="form-control"
                                type="date"
                                max='9999-12-31'
                                disabled={action === 2 && !editMode}
                                value={model.StartDate ? model.StartDate : ''}
                                onChange={({ target: { value } }) => this.changeStandardField("StartDate", value)}
                                onBlur={({ target }) => this.changeDateField(1, model.StartDate, target)} />
                        </div>

                        {/* Fecha final - EndDate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Fecha final </span>
                            </div>
                            <input
                                id="inputEndDate"
                                className="form-control"
                                type="date"
                                disabled={action === 2 && !editMode}
                                value={model.EndDate ? model.EndDate : ''}
                                onChange={({ target: { value } }) => this.changeStandardField("EndDate", value)}
                                onBlur={({ target }) => this.changeDateField(2, model.EndDate, target)} />
                        </div>

                        {/* Visualizar en periodos - ViewForm */}
                        <div className='input-group mb-3'>
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Mostrar en periodos de </span>
                            </div>
                            <input
                                id='itemDocumentSearch'
                                className="form-control text-right"
                                type="text"
                                autoComplete="off"
                                disabled={action === 2 && !editMode}
                                value={model.PeriodsLen || ""}
                                onChange={({ target: { value } }) => this.changeStandardField("PeriodsLen", value)} />
                            <div className="input-group-append" >
                                <select
                                    id="inputViewForm"
                                    className="form-control"
                                    disabled={action === 2}
                                    style={{ minWidth: 100 }}
                                    value={model.GrpPeriods || "D"}
                                    onChange={({ target: { value } }) => this.changeTypeView(value)}>
                                    <option value="D"> Días </option>
                                    <option value="W"> Semanas </option>
                                    <option value="M"> Meses </option>
                                </select>
                            </div>
                        </div>

                        {/* Visualizar en periodos - ViewForm */}
                        <div className='input-group mb-3'>
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Longitud de horizonte </span>
                            </div>
                            <input
                                id='itemDocumentSearch'
                                className="form-control text-right"
                                type="text"
                                autoComplete="off"
                                disabled={action === 2 && !editMode}
                                value={model.HorizonLength || ""}
                                onChange={({ target: { value } }) => this.changeHorizon(value)} />
                            <div className="input-group-append" >
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" style={{ minWidth: 110 }}> {model.GrpPeriods === "M" ? "Meses" : model.GrpPeriods === "W" ? "Semanas" : "Días"} </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*Segunda columna*/}
                    <div className="col-12 col-lg-6">
                        <h5 className="mb-3"> Considerar feriados para: </h5>

                        {/* Fecha final - EndDate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbProdItems"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.HldaysProd === "Y"}
                                        onChange={() => this.changeChecked("HldaysProd", !(model.HldaysProd === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbProdItems"> Artículos en producción </label>
                        </div>

                        {/* Fecha final - EndDate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbPurItems"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.HldaysPurc === "Y"}
                                        onChange={() => this.changeChecked("HldaysPurc", !(model.HldaysPurc === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbPurItems"> Artículos en compras </label>
                        </div>

                        <div className="input-group mb-3">
                            <div className="form-control border-0 p-0"> <hr /> </div>
                        </div>

                        {/* Visualizar - ViewForm */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbFabCicle"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.IgnoreCLT === "Y"}
                                        onChange={() => this.changeChecked("IgnoreCLT", !(model.IgnoreCLT === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbFabCicle"> Ignorar ciclo de fabricación acumulado </label>
                        </div>
                    </div>
                </div>
                <h5 className="mt-2"> Visualizar preferencias </h5>
                <div className="row pr-0 mt-3">
                    {/* Primera Columna */}
                    <div className="col-12 col-lg-6">
                        {/* Visualizar en periodos - ViewForm */}
                        <div className='input-group mb-3'>
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Clasificar por </span>
                            </div>
                            <select
                                id="inputViewForm"
                                className="form-control"
                                disabled={action === 2 && !editMode}
                                value={model.SortBy}
                                onChange={({ target: { value } }) => this.changeStandardField("SortBy", value)} >
                                <option value="L"> Secuencia conjunto </option>
                                <option value="C"> Número de artículo </option>
                                <option value="N"> Descripción del artículo </option>
                                <option value="G"> Grupo de artículos </option>
                            </select>
                        </div>

                        {/* Visualizar - ViewForm */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbViewReqItems"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ItmReq === "Y"}
                                        onChange={() => this.changeChecked("ItmReq", !(model.ItmReq === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbViewReqItems"> Visualizar artículos sin requisitos </label>
                        </div>
                    </div>

                    {/*Segunda columna*/}
                    <div className="col-12 col-lg-6">

                        {/* Visualizar - ViewForm */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbViewSelectItems"
                                        disabled={action === 2 && !editMode}
                                        type="checkbox"
                                        checked={model.DisSelItem === "Y"}
                                        onChange={() => this.changeChecked("DisSelItem", !(model.DisSelItem === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbViewSelectItems"> Visualizar solo los artículos seleccionados </label>
                        </div>

                        {/* Visualizar - ViewForm */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbSimulation"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.Simulation === "Y"}
                                        onChange={() => this.changeChecked("Simulation", !(model.Simulation === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbSimulation"> Simulación </label>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    renderItems() {
        const { action, model } = this.props;
        const { editMode, ListItemsGroup, searchItemModel } = this.state;

        return (
            <>
                {this.state.mountSelectItemsModal &&
                    <MRPAssistanceItems
                        ListItemsGroup={ListItemsGroup}
                        SearchItemModel={searchItemModel}
                        ChangeAnyPropInstate={this.ChangeAnyPropInstate}
                        CloseActions={this.CloseActionsItemsSearch}
                        ChargeItemsInTabAsMayBeFilters={this.ChargeItemsInTabAsMayBeFilters}
                    />
                }
                <h4> Selección de artículos </h4>
                <p className="mb-3"> Para planificar las necesidades de todos los artículos con el método planificación "MRP", seleccione "Artículos (todos)". Para planificar las necesidades de artículos específicos, seleccione "Artículos seleccionados" y el botón "Añadir artículos". </p>
                <div className="row pr-0">
                    <div className="col-12 col-lg-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="rdAllItems-Y"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.AllItems === "Y"}
                                        onChange={() => this.ChangeItemsType("Y")} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="rdAllItems-Y"> Artículos (todos) </label>
                        </div>

                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="rdAllItems-N"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.AllItems === "N"}
                                        onChange={() => this.ChangeItemsType("N")} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="rdAllItems-N"> Artículos seleccionados </label>
                        </div>
                    </div>

                    {/* Segunda Columna */}
                    <div className="col-12 col-lg-6">
                        <div className="d-flex flex-column align-items-end">
                            <div className="input-group mb-3 w-100">
                                <button className={`btn ${model.AllItems === "Y" ? "btn-secondary" : "btn-outline-success"} ml-auto`}
                                    disabled={model.AllItems === "Y"}
                                    onClick={this.OpenSelectItemsModal}>
                                    <span> <i className="fa fa-plus-circle mr-2" /> Agregar artículos </span>
                                </button>
                            </div>
                            <div className="input-group mb-3 w-100">
                                {/* <button className="btn btn-secondary ml-auto" onClick={() => { }}>
                                    <span className="d-none d-sm-inline">Actualizar seleccionados</span>
                                </button> */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-around">
                    <div className="col-12">
                        <div>
                            <table className="table table-scroll" style={{ fontSize: 14 }} id="bodyModal" >
                                <div
                                    className="w-100"
                                    aria-labelledby="nav-home-tab-Contenido"
                                    style={{ minHeight: 350, maxHeight: 350 }}>
                                    <table
                                        id="dataTableDocuments"
                                        className="display" >
                                        <thead className="table-header-yellow">
                                            <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                <td className="sticky-header" style={{ maxWidth: 20 }} > # </td>
                                                <td className="sticky-header" > Artículo </td>
                                                <td className="sticky-header" > Descripción </td>
                                                <td className="sticky-header form-check" style={{ marginTop: "10px" }}>
                                                    <input type="checkbox" checked={this.state.CheckSelectAllItems === 'Y' ? true : false} onChange={() => this.ChangeAllItemsSelected()} disabled={action === 2 && !editMode} />
                                                </td>
                                                <td className="sticky-header">
                                                    <button
                                                        type="button"
                                                        style={{ color: '#c42222' }}
                                                        className="btn"
                                                        onClick={() => this.DeleteAllItems()}>
                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                    </button>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {model.ItmArray.map((line, index) =>
                                                <tr key={`itemRow${index}`}>
                                                    <td style={{ maxWidth: 20 }}> {index + 1} </td>
                                                    <td> {line.ItemCode} </td>
                                                    <td> {line.ItemName} </td>
                                                    <td className="form-check"> <input type="checkbox" disabled={action === 2 && !editMode} onChange={() => this.ChangeSelectLineItem(index)} checked={line.Selected === "Y"} /> </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            style={{ backgroundColor: 'transparent', padding: 5, color: 'red', }}
                                                            className="btn"
                                                            onClick={() => this.DeleteItemLine(index)}
                                                        >
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    </td>
                                                    {/* {!(action === 2 && !editMode) && <th className='sticky-columns' style={{ backgroundColor: '#fff' }}> Acciones </th>} */}
                                                </tr>
                                            )}
                                            {/* {!(action === 2 && !editMode) &&
                                                <tr>
                                                    <td colSpan={3} className="sticky-column" style={{ backgroundColor: "#FFF", minWidth: 300, maxWidth: 300 }}>
                                                        <div className="input-group">
                                                            <input
                                                                id="itemDocumentSearch"
                                                                className="form-control "
                                                                type="text"
                                                                placeholder="Artículo"
                                                                autoComplete="off" />
                                                            <div className="input-group-append" >
                                                                <button type="button" className="btn btn-outline-warning" onClick={this.openItemsModal}>
                                                                    <i className="fa fa-filter" aria-hidden="true" size="10" />
                                                                </button>
                                                            </div>
                                                            <div className="input-group-append" >
                                                                <button type="button" className="btn btn-outline-success" onClick={this.openItemsModal}>
                                                                    <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            } */}
                                        </tbody>
                                    </table>
                                </div>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    renderWarehouses() {
        const { action, model } = this.props;
        const { editMode } = this.state;

        return (
            <>
                <h4> Selección de datos de inventario </h4>
                <p className="mb-3"> Defina los emplazamientos, los almacenes, y las fuentes de oferta y demanda que se incluirán en la ejecución MRP. </p>
                <div className="row pr-0">
                    <div className="col-12">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="rdByCompany-Y"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ByCompany === "Y"}
                                        onChange={() => this.changeChecked("ByCompany", true)} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="rdByCompany-Y"> Empresa- Consolidar el inventario existente, la oferta y la demanda únicamente en el almacén estándar. </label>
                        </div>

                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="rdByCompany-N"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ByCompany === "N"}
                                        onChange={() => this.changeChecked("ByCompany", false)} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="rdByCompany-N"> Almacén- Incluir el inventario existente, la oferta y la demanda Para cada almacén de manera separada. </label>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-around">
                    <div className="col-12">
                        <div>
                            <table className="table table-scroll" style={{ fontSize: 14 }} id="bodyModal" >
                                <div
                                    className="w-100"
                                    aria-labelledby="nav-home-tab-Contenido"
                                    style={{ minHeight: 350, maxHeight: 350 }}>
                                    <table
                                        id="dataTableDocuments"
                                        className="display" >
                                        <thead className="table-header-yellow">
                                            <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                <td className="p-2">
                                                    Incluir inventario
                                                    <div className="text-center form-check center-grid mt-2">
                                                        <input
                                                            id={`cbExtIvntSelAll`}
                                                            disabled={action === 2 && !editMode}
                                                            type="checkbox"
                                                            checked={model.WhsChecks.ExtIvntSel}
                                                            onChange={() => this.changeAllWhsField("ExtIvntSel", !model.WhsChecks.ExtIvntSel)} />
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    Incluir demanda
                                                    <div className="text-center form-check center-grid mt-2">
                                                        <input
                                                            id={`cbExtIvntSelAll`}
                                                            disabled={action === 2 && !editMode}
                                                            type="checkbox"
                                                            checked={model.WhsChecks.InvtSel}
                                                            onChange={() => this.changeAllWhsField("InvtSel", !model.WhsChecks.InvtSel)} />
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    Incluir oferta
                                                    <div className="text-center form-check center-grid mt-2">
                                                        <input
                                                            id={`cbExtIvntSelAll`}
                                                            disabled={action === 2 && !editMode}
                                                            type="checkbox"
                                                            checked={model.WhsChecks.ReqSel}
                                                            onChange={() => this.changeAllWhsField("ReqSel", !model.WhsChecks.ReqSel)} />
                                                    </div>
                                                </td>
                                                <td className="p-2"> Código de almacén </td>
                                                <td className="p-2"> Nombre de almacén </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {model.WhsArray.map((whs, index) =>
                                                <tr key={`whsRow${index}`}>
                                                    <td className={`dt-row-${index % 2 === 0 ? 'primary' : 'secondary'}`}>
                                                        <div className="text-center form-check center-grid">
                                                            <input
                                                                id={`cbExtIvntSel${index}`}
                                                                disabled={action === 2 && !editMode}
                                                                type="checkbox"
                                                                checked={whs.ExtIvntSel === "Y"}
                                                                onChange={() => this.changeWhsField(index, "ExtIvntSel", !(whs.ExtIvntSel === "Y"))} />
                                                        </div>
                                                    </td>
                                                    <td className={`dt-row-${index % 2 === 0 ? 'primary' : 'secondary'}`}>
                                                        <div className="text-center form-check center-grid">
                                                            <input
                                                                id={`cbInvtSelSel${index}`}
                                                                disabled={action === 2 && !editMode}
                                                                type="checkbox"
                                                                checked={whs.InvtSel === "Y"}
                                                                onChange={() => this.changeWhsField(index, "InvtSel", !(whs.InvtSel === "Y"))} />
                                                        </div>
                                                    </td>
                                                    <td className={`dt-row-${index % 2 === 0 ? 'primary' : 'secondary'}`}>
                                                        <div className="text-center form-check center-grid">
                                                            <input
                                                                id={`cbReqSel${index}`}
                                                                disabled={action === 2 && !editMode}
                                                                type="checkbox"
                                                                checked={whs.ReqSel === "Y"}
                                                                onChange={() => this.changeWhsField(index, "ReqSel", !(whs.ReqSel === "Y"))} />
                                                        </div>
                                                    </td>
                                                    <td className={`dt-row-${index % 2 === 0 ? 'primary' : 'secondary'} text-center`}> {whs.WhsCode || ""} </td>
                                                    <td className={`dt-row-${index % 2 === 0 ? 'primary' : 'secondary'} text-center`}> {decodeText(whs.WhsName) || ""} </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    renderDocuments() {
        const { action, model, forecastList } = this.props;
        const { editMode } = this.state;
        const forecastSelected = forecastList.find(({ AbsID }) => Number(AbsID) === Number(model.FCTAbs));

        return (
            <>
                <h4> Fuente de datos de documentos </h4>
                <p className="mb-3"> Defina las fuentes de datos y los documentos que se incluirán en el cálculo MRP. </p>

                <h5 className="mt-3"> Rango de tiempo </h5>
                <div className="row pr-0 mt-3">
                    <div className="col-12 col-lg-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="rdIncHisData-Y"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.IncHisData === "N"}
                                        onChange={() => this.changeChecked("IncHisData", true)} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="rdIncHisData-Y"> Dentro del horizonte de planificación </label>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="rdIncHisData-N"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.IncHisData === "Y"}
                                        onChange={() => this.changeChecked("IncHisData", false)} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="rdIncHisData-N"> Incluir datos históricos </label>
                        </div>
                    </div>
                </div>

                <div className="row pr-0 mt-3">
                    {/* Fuente de datos */}
                    <div className="col-12 col-lg-6">
                        <h5 className="mb-3"> Fuentes de oferta y demanda </h5>
                        {/* Solicitudes de compra - PurchReq */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbPurchReq"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.PurchReq === "Y"}
                                        onChange={() => this.changeChecked("PurchReq", !(model.PurchReq === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbPurchReq"> Solicitudes de compra </label>
                        </div>

                        {/* Ofertas de compra - PurchQuota */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbPurchQuota"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.PurchQuota === "Y"}
                                        onChange={() => this.changeChecked("PurchQuota", !(model.PurchQuota === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbPurchQuota"> Ofertas de compra </label>
                        </div>

                        {/* Ordenes de compra - PurchOrder */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbPurchOrder"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.PurchOrder === "Y"}
                                        onChange={() => this.changeChecked("PurchOrder", !(model.PurchOrder === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbPurchOrder"> Ordenes de compra </label>
                        </div>

                        {/* Acuerdos de compra globales - PurchOAT */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbPurchOAT"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.PurchOAT === "Y"}
                                        onChange={() => this.changeChecked("PurchOAT", !(model.PurchOAT === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbPurchOAT"> Acuerdos de compra globales </label>
                        </div>

                        {/* Ofertas de venta - SalesQuota */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbSalesQuota"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.SalesQuota === "Y"}
                                        onChange={() => this.changeChecked("SalesQuota", !(model.SalesQuota === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbSalesQuota"> Ofertas de venta </label>
                        </div>

                        {/* Órdenes de venta - SalesOrder */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbSalesOrder"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.SalesOrder === "Y"}
                                        onChange={() => this.changeChecked("SalesOrder", !(model.SalesOrder === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbSalesOrder"> Órdenes de venta </label>
                        </div>

                        {/* Acuerdos de venta globales - SalesOAT */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbSalesOAT"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.SalesOAT === "Y"}
                                        onChange={() => this.changeChecked("SalesOAT", !(model.SalesOAT === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbSalesOAT"> Acuerdos de venta globales </label>
                        </div>

                        {/* Órdenes de fabricación - WorkOrder */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbWorkOrder"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.WorkOrder === "Y"}
                                        onChange={() => this.changeChecked("WorkOrder", !(model.WorkOrder === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbWorkOrder"> Órdenes de fabricación </label>
                        </div>

                        {/* Solicitudes de trasladoWtrqate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbWtrq"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.Wtrq === "Y"}
                                        onChange={() => this.changeChecked("Wtrq", !(model.Wtrq === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbWtrq"> Solicitudes de traslado </label>
                        </div>

                        {/* Facturas previas -ResInve */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbResInv"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ResInv === "Y"}
                                        onChange={() => this.changeChecked("ResInv", !(model.ResInv === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbResInv"> Facturas previas </label>
                        </div>

                        {/* Transacciones de orden recurrenteRotsate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbRots"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.Rots === "Y"}
                                        onChange={() => this.changeChecked("Rots", !(model.Rots === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbRots"> Transacciones de orden recurrente </label>
                        </div>
                    </div>

                    {/* Restricciones */}
                    <div className="col-12 col-lg-6">
                        <h5 className="mb-3"> Restricciones </h5>
                        {/* ontrol" htmlFor=""> Restringir solicitudes de compra - ExpdPurReq */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpdPurReq"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpdPurReq === "Y"}
                                        onChange={() => this.changeChecked("ExpdPurReq", !(model.ExpdPurReq === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpdPurReq"> Restringir solicitudes de compra </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir ofertas de compra - ExpdPQuota */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpdPQuota"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpdPQuota === "Y"}
                                        onChange={() => this.changeChecked("ExpdPQuota", !(model.ExpdPQuota === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpdPQuota"> Restringir ofertas de compra </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir órdenes de compra - ExpandedPO */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpandedPO"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpandedPO === "Y"}
                                        onChange={() => this.changeChecked("ExpandedPO", !(model.ExpandedPO === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpandedPO"> Restringir órdenes de compra </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir acuerdos de compra globales - ExpdPAgree */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpdPAgree"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpdPAgree === "Y"}
                                        onChange={() => this.changeChecked("ExpdPAgree", !(model.ExpdPAgree === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpdPAgree"> Restringir acuerdos de compra globales </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir ofertas de venta - ExpdSQuota */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpdSQuota"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpdSQuota === "Y"}
                                        onChange={() => this.changeChecked("ExpdSQuota", !(model.ExpdSQuota === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpdSQuota"> Restringir ofertas de venta </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir órdenes de venta - ExpandedSO */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpandedSO"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpandedSO === "Y"}
                                        onChange={() => this.changeChecked("ExpandedSO", !(model.ExpandedSO === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpandedSO"> Restringir órdenes de venta </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir acuerdos de venta globales - ExpdSAgree */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpdSAgree"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpdSAgree === "Y"}
                                        onChange={() => this.changeChecked("ExpdSAgree", !(model.ExpdSAgree === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpdSAgree"> Restringir acuerdos de venta globales </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir órdenes de fabricación - ExpdWOR */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpdWOR"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpdWOR === "Y"}
                                        onChange={() => this.changeChecked("ExpdWOR", !(model.ExpdWOR === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpdWOR"> Restringir órdenes de fabricación </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir solicitudes de traslado - ExpdTraReq */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpdTraReq"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpdTraReq === "Y"}
                                        onChange={() => this.changeChecked("ExpdTraReq", !(model.ExpdTraReq === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpdTraReq"> Restringir solicitudes de traslado </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>

                        {/* Restringir facturas previas - ExpdResINV */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbExpdResINV"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.ExpdResINV === "Y"}
                                        onChange={() => this.changeChecked("ExpdResINV", !(model.ExpdResINV === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbExpdResINV"> Restringir facturas previas </label>
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openItemsModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Nivel de stock y previsiones */}
                    <div className="col-12 col-lg-6">
                        {/* Nivel de stock - InvtLevel */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text"> Nivel de stock </span>
                            </div>
                            <select
                                id="inputViewForm"
                                className="form-control"
                                // disabled={action === 2}
                                value={model.InvtLevel || ""}
                                onChange={({ target: { value } }) => this.changeStandardField("InvtLevel", value)} >
                                <option value="-"> Ninguno </option>
                                <option value="A"> Máximo </option>
                                <option value="I"> Mínimo </option>
                                <option value="M"> Máximo - Mínimo </option>
                                <option value="R"> Requerido </option>
                            </select>
                        </div>

                        {/* Previsión - FCTAbs */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text"> Previsión </span>
                            </div>
                            <input className="form-control" disabled value={forecastSelected ? forecastSelected.Code : model.FCTAbs === -999 ? "Multiples previsiones" : ""} />
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openForecastModal}>
                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <h5 className="mt-3"> Recomendaciones </h5>
                <div className="row pr-0 mt-3">
                    <div className="col-12 col-lg-6">
                        {/* Fecha final - EndDate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbPurchase"
                                        type="checkbox"
                                        disabled
                                        checked />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbPurchase"> Compras </label>
                        </div>

                        {/* Solicitudes de compra - RcmPO */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="cbRcmPO-Y"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.RcmPO === "N"}
                                        onChange={() => this.changeChecked("RcmPO", false)} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbRcmPO-Y"> Solicitudes de compra </label>
                        </div>

                        {/* Órdenes de compra - RcmPO */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="cbRcmPO-N"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.RcmPO === "Y"}
                                        onChange={() => this.changeChecked("RcmPO", true)} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbRcmPO-N"> Órdenes de compra </label>
                        </div>

                        <div className="input-group mb-3">
                            <div className="form-control border-0 p-0"> <hr /> </div>
                        </div>

                        {/* Órdenes de fabricación - RcmWO */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbRcmWO"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.RcmWO === "Y"}
                                        onChange={() => this.changeChecked("RcmWO", !(model.RcmWO === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbRcmWO"> Órdenes de fabricación </label>
                        </div>

                        {/* Solicitudes de traslado - RcmWTRQ */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        id="cbRcmWTRQ"
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        checked={model.RcmWTRQ === "Y"}
                                        onChange={() => this.changeChecked("RcmWTRQ", !(model.RcmWTRQ === "Y"))} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="cbRcmWTRQ"> Solicitudes de traslado </label>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6">
                        {/* Generar en almacén predeterminado de artículos - RCMDefWhs */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="rbRCMDefWhs-Y"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.RCMDefWhs === "Y"}
                                        onChange={() => this.changeChecked("RCMDefWhs", true)} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="rbRCMDefWhs-Y"> Generar en almacén predeterminado de artículos </label>
                        </div>

                        {/* Generar en almacén con demanda - RCMDefWhs */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        id="rbRCMDefWhs-N"
                                        type="radio"
                                        disabled={action === 2 && !editMode}
                                        checked={model.RCMDefWhs === "N"}
                                        onChange={() => this.changeChecked("RCMDefWhs", false)} />
                                </span>
                            </div>
                            <label className="form-control" htmlFor="rbRCMDefWhs-N"> Generar en almacén con demanda </label>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    renderHomeV2() {
        const { action, model, groupsItemData } = this.props;
        
        const { editMode } = this.state;
        return (<>
            <h4> Detalles de planificación </h4>
            <div className="row pr-0 mt-4">
                <div className="col-12 col-lg-6">
                    <div className='input-group mb-3'>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Grupo de Artículos </span>
                        </div>
                        <select
                            id="selItemSegment"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.itmsGrpCod}
                            onChange={({ target: { value } }) => this.changeStandardField("itmsGrpCod", value)} >
                            <option value=""> Seleccionar </option>
                            {Array.isArray(groupsItemData) ?
                                groupsItemData.map(group => <option value={group.ItmsGrpCod}> {group.ItmsGrpNam} </option>)
                                : ""
                            }
                        </select>
                    </div>
                </div>
            </div>

            <div className="row pr-0">
                <div className="col-12 col-lg-6"> {/* Fecha de inicio - StartDate */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Fecha de inicio </span>
                        </div>
                        <input
                            id="inputStartDate"
                            className="form-control"
                            type="date"
                            max='9999-12-31'
                            disabled={action === 2 && !editMode}
                            value={model.StartDate ? model.StartDate : ''}
                            onChange={({ target: { value } }) => this.changeStandardField("StartDate", value)}
                            onBlur={({ target }) => this.changeDateField(1, model.StartDate, target)} />
                    </div>
                </div>

                <div className="col-12 col-lg-6"> {/* Fecha final - EndDate */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Fecha final </span>
                        </div>
                        <input
                            id="inputEndDate"
                            className="form-control"
                            type="date"
                            disabled={action === 2 && !editMode}
                            value={model.EndDate ? model.EndDate : ''}
                            onChange={({ target: { value } }) => this.changeStandardField("EndDate", value)}
                            onBlur={({ target }) => this.changeDateField(2, model.EndDate, target)} />
                    </div>
                </div>

                <div className="col-12 col-lg-6"> {/* Visualizar en periodos - ViewForm */}
                    <div className='input-group mb-3'>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Mostrar en periodos de </span>
                        </div>
                        <input
                            id='itemDocumentSearch'
                            className="form-control text-right"
                            type="text"
                            autoComplete="off"
                            disabled={true}
                            value={model.PeriodsLen || ""}
                            onChange={({ target: { value } }) => this.changeStandardField("PeriodsLen", value)} />
                        <div className="input-group-append" >
                            <select
                                id="inputViewForm"
                                className="form-control"
                                disabled={action === 2}
                                style={{ minWidth: 100 }}
                                value={model.GrpPeriods || "D"}
                                onChange={({ target: { value } }) => this.changeTypeView(value)}>
                                <option value="D"> Días </option>
                                <option value="W"> Semanas </option>
                                <option value="M"> Meses </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-6"> {/* Visualizar en periodos - ViewForm */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Longitud de horizonte </span>
                        </div>
                        <input
                            id='itemDocumentSearch'
                            className="form-control text-right"
                            type="text"
                            autoComplete="off"
                            disabled={action === 2 && !editMode}
                            value={model.HorizonLength || ""}
                            onChange={({ target: { value } }) => this.changeHorizon(value)} />
                        <div className="input-group-append" >
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" style={{ minWidth: 110 }}> {model.GrpPeriods === "M" ? "Meses" : model.GrpPeriods === "W" ? "Semanas" : "Días"} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {this.state.totalDocs > 0 ?
                <div>
                    Documentos Creados:{this.state.currDoc}/{this.state.totalDocs}
                </div> : <></>
            }


        </>)
    }

    renderResults() {
        const { model } = this.props;
        const { recommendations, informe, showResultDetails, documents } = this.state;
        const items = Object.keys(informe);

        const meses = Array.from(
            new Set(
                items.reduce((acc, item) => {
                    return acc.concat(informe[item].map(entry => entry.Date.slice(0, 7)));
                }, [])
            )
        ).sort();

        const obtenerValor = (item, mes, categoria) => {
            const valor = Number(informe[item].find(entry => entry.Date.startsWith(mes))?.[categoria]).toFixed(0);
            return valor || '';
        };

        return (
            <>
                <h4> Resultados PNM </h4>
                <p className="mb-3"> En la pestaña "Informe", puede alternar la cantidad de inventario final antes o después de la ejecución MRP con la casilla "Vista previa de resultados de ejecución MRP". </p>
                <div className="row pr-0">
                    {/* Primera Columna */}
                    <div className="col-12 col-lg-8">
                        {/* Fecha final - EndDate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline"> Horizonte de planificación</span>
                                    <span className="d-inline d-xl-none">Horizonte Planif</span>
                                </span>
                            </div>
                            <div className="form-control text-right"> {moment(model.StartDate).format("DD/MM/YYYY")} - {moment(model.EndDate).format("DD/MM/YYYY")} </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-4">
                        {/* Fecha final - EndDate */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold"> Calculado a las </span>
                            </div>
                            <div className="form-control text-right"> {moment().format("HH:mm")} </div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-around">
                    <ul className="nav nav-tabs w-100" id="myTab" role="tablist">
                        {/* <li className="nav-item ml-3">
                            <a className="nav-link font-weight-bold text-secondary active" id="report-tab" data-toggle="tab" href="#report" role="tab" aria-controls="report" aria-selected="true"> Informe </a>
                        </li> */}
                        <li className="nav-item">
                            <a className="nav-link font-weight-bold text-secondary active" id="recommendations-tab" data-toggle="tab" href="#recommendations" role="tab" aria-controls="items" aria-selected="true"> Recomendaciones </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link font-weight-bold text-secondary" id="documentsMRP-tab" data-toggle="tab" href="#documentsMRP" role="tab" aria-controls="items" aria-selected="true"> Documentos </a>
                        </li>
                    </ul>

                    <div className="tab-content container border border-top-0 pt-3">
                        <div className="tab-pane fade " id="report" role="tabpanel" aria-labelledby="report-tab">
                            <div className="row pr-0">
                                {/* Primera Columna */}
                                <div className="col-12 col-lg-6">
                                    {/* Fecha final - EndDate */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text form-check"> <input id="chPreView" type="checkbox" checked={model.showMRPResults} onChange={() => this.updateModel("showMRPResults", !model.showMRPResults)} /> </span>
                                        </div>
                                        <label className="form-control" htmlFor="chPreView"> Vista previa de resultados de ejecución MRP </label>
                                    </div>
                                </div>

                                <div className="col-12 col-lg-6">
                                    {/* Fecha final - EndDate */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend form-check">
                                            <span className="input-group-text"> <input id="chFilterItems" type="checkbox" /> </span>
                                        </div>
                                        <label className="form-control" htmlFor="chFilterItems"> Filtrar posibles artículos problemáticos </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row justify-content-around">
                                <div className="col-12">
                                    <div>
                                        <table className="table table-scroll" style={{ fontSize: 14 }} id="bodyModal" >
                                            <div
                                                className="w-100"
                                                aria-labelledby="nav-home-tab-Contenido"
                                                style={{ minHeight: 300, maxHeight: 350 }}>
                                                <table
                                                    id="dataTableDocuments"
                                                    className="display" >
                                                    <thead className="table-header-yellow">
                                                        <tr style={{ backgroundColor: '#d2ab24', textAlign: 'left' }}>
                                                            <th className="p-2 border"> Artículo </th>
                                                            {meses.map(mes => <th key={mes} className="p-2 border"> {mes} </th>)}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {items.map((item, index) => (
                                                            <React.Fragment key={item}>
                                                                <tr className="font-weight-bold">
                                                                    <td className="p-2 border" onClick={() => this.resultDetails(index)} style={{ cursor: "pointer" }}> <i className={`fa fa-caret-${showResultDetails[index] ? "down" : "right"} mr-2`} /> {item} </td>
                                                                    {meses.map(mes => {
                                                                        const value = Number(obtenerValor(item, mes, 'Oferta'));
                                                                        if (!value) return (<td key={`general-${item}-${mes}`} className="border p-2">  </td>);
                                                                        return (<td key={`general-${item}-${mes}`} className="border p-2 text-center" style={{ cursor: "pointer" }} onClick={() => this.getPeggingInformation(item, mes, "R")}> {value} </td>);
                                                                    })}
                                                                </tr>
                                                                {showResultDetails[index] &&
                                                                    <>
                                                                        <tr>
                                                                            <td className="border p-2 pl-4">Inventario inicial</td>
                                                                            {meses.map(mes => {
                                                                                const value = Number(obtenerValor(item, mes, model.showMRPResults ? 'InitInvent' : 'OrgInitInvnt'));
                                                                                if (!value) return (<td key={`general-${item}-${mes}`} className="border p-2">  </td>);
                                                                                return (<td key={`general-${item}-${mes}`} className={`border p-2 text-center ${value < 0 ? "stock-error" : ""}`}> {value} </td>);
                                                                            })}
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="border p-2 pl-4">Oferta</td>
                                                                            {meses.map(mes => {
                                                                                const value = Number(obtenerValor(item, mes, model.showMRPResults ? 'SupplyData' : 'null'));
                                                                                if (!value) return (<td key={`oferta-${item}-${mes}`} className="border p-2 text-center"> </td>);
                                                                                return (<td key={`general-${item}-${mes}`} className="border p-2 text-center" style={{ cursor: "pointer" }} onClick={() => this.getPeggingInformation(item, mes, "R")}> {value} </td>);
                                                                            })}
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="border p-2 pl-4">Demanda</td>
                                                                            {meses.map(mes => {
                                                                                const value = Number(obtenerValor(item, mes, 'Demanda'));
                                                                                if (!value) return (<td key={`oferta-${item}-${mes}`} className="border p-2 text-center"> </td>);
                                                                                return (<td key={`general-${item}-${mes}`} className="border p-2 text-center" style={{ cursor: "pointer" }} onClick={() => this.getPeggingInformation(item, mes, "I")}> {value} </td>);
                                                                            })}
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="border p-2 pl-4">Inventario final</td>
                                                                            {meses.map(mes => {
                                                                                const value = Number(obtenerValor(item, mes, model.showMRPResults ? 'FinalInvent' : 'OrgFinalInvent'));
                                                                                if (!value) return (<td key={`general-${item}-${mes}`} className="border p-2">  </td>);
                                                                                return (<td key={`general-${item}-${mes}`} className={`border p-2 text-center ${value < 0 ? "stock-error" : ""}`}> {value} </td>);
                                                                            })}
                                                                        </tr>
                                                                    </>
                                                                }
                                                            </React.Fragment>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="tab-pane fade show active" id="recommendations" role="tabpanel" aria-labelledby="recommendations-tab">

                            <div className="row justify-content-around">
                                <div className="col-12">
                                    <div>
                                        <table className="table table-scroll" style={{ fontSize: 14 }} id="bodyModal" >
                                            <div
                                                className="w-100"
                                                aria-labelledby="nav-home-tab-Contenido"
                                                style={{ minHeight: 300, maxHeight: 350 }}>
                                                <table
                                                    id="dataTableDocuments"
                                                    className="display" >
                                                    <thead className="table-header-yellow">
                                                        <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                            <td style={{ maxWidth: 20 }}> # </td>
                                                            <td> Tipo de pedido </td>
                                                            <td> Artículo </td>
                                                            <td> Descripción </td>
                                                            <td> Cantidad </td>
                                                            <td> Fecha de liberación </td>
                                                            <td> Fecha de vencimiento </td>
                                                            <td> Almacén </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {recommendations.map((line, index) =>
                                                            <tr>
                                                                <td style={{ maxWidth: 20 }}> {index + 1} </td>
                                                                <td> {docTypeRecommendation(line.OrderType)} </td>
                                                                <td> {line.ItemCode} </td>
                                                                <td> {line.ItemName} </td>
                                                                <td> {line.Quantity} </td>
                                                                <td> {moment(line.ReleasDate).format("DD/MM/YYYY")} </td>
                                                                <td> {moment(line.DueDate).format("DD/MM/YYYY")} </td>
                                                                <td> {line.Warehouse} </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="documentsMRP" role="tabpanel" aria-labelledby="documentsMRP-tab">
                            <div className="row justify-content-around">
                                <div className="col-12">
                                    <div>
                                        <table className="table table-scroll" style={{ fontSize: 14 }} id="bodyModal" >
                                            <div
                                                className="w-100"
                                                aria-labelledby="nav-home-tab-Contenido"
                                                style={{ minHeight: 300, maxHeight: 350 }}>
                                                <table
                                                    id="dataTableDocumentsMRP"
                                                    className="display" >
                                                    <thead className="table-header-yellow">
                                                        <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                            <td style={{ maxWidth: 20 }}> # </td>
                                                            <td> Documento </td>
                                                            <td> Sucursal </td>
                                                            <td> Fecha </td>
                                                            <td> Estatus </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {documents.map((doc, index) =>
                                                            <tr>
                                                                <td style={{ maxWidth: 20 }}> {index + 1} </td>
                                                                <td> {doc.DocEntry} - {doc.DocNum} </td>
                                                                <td> {doc.Warehouse} </td>
                                                                <td> {moment(doc.ReleasDate).format("DD/MM/YYYY")} </td>
                                                                <td> {doc.docCreated ? 'En autorización' : doc?.Message ?? 'ERROR'} </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        );
    }

    validateModel = async () => {
        const { warningModel, editMode, currDoc } = this.state;


        const { createScenario, model, action, showAlert } = this.props
        if (currDoc > 0) {
            this.sendDocuments();
        } else {
            // MRP V1
            // if (!model.MsnCode) {
            //     return showAlert({ type: 'error', message: 'Escriba un nombre para el escenario' });
            // }
            // if (!model.GrpPeriods) {
            //     return showAlert({ type: 'error', message: 'Asigne un grupo de periodos' });
            // }
            // if (!model.PeriodsLen) {
            //     return showAlert({ type: 'error', message: 'Asigne un tamaño de periodo' });
            // }
            // if (!moment(model.StartDate).isValid()) {
            //     return showAlert({ type: 'error', message: 'Asigne una fecha de inicio' });
            // }
            // if (!moment(model.EndDate).isValid()) {
            //     return showAlert({ type: 'error', message: 'Asigne una fecha final' });
            // }
            // warningModel.accept = (() => { createScenario(model); });
            // END MRP V1

            //MRP V2
            warningModel.accept = (() => { this.createMRPProcessV2(); });

            //END MRP V2

            if (action === 1) {
                warningModel.message = "¿Desea continuar?";
                warningModel.acceptMsg = "Guardar";
            }

            await this.setState({
                warningModel,
                showWarningModal: true,
            });
            $("#warningModal").modal("show");

            $("#warningModal").on("hidden.bs.modal", async () => {
                warningModel.accept = null;
                warningModel.message = null;
                warningModel.acceptMsg = null;
                warningModel.cancelMsg = null;
                await this.setState({
                    showWarningModal: false,
                    warningModel,
                });
            });
        }
    }

    saveRecommendations = async () => {
        const { enableSpinner, model, showAlert } = this.props
        if (this.state.recommendations.length > 0) {
            enableSpinner(true)
            const response = await apiClient.saveRecommendations(this.state.recommendations || [])
            enableSpinner(false)
            if (response.status === SERVICE_RESPONSE.SUCCESS) {
                showAlert({ type: 'success', message: response.message || 'RECOMENDACIONES GUARDADAS' })
                this.setState({
                    saveRecommendations: false,
                    // recommendations:[]
                })
            } else {
                showAlert({ type: 'error', message: response.message || 'NO SE GUARDARON LAS RECOMENDACIONES' })
            }
        } else { showAlert({ type: 'info', message: 'NO HAY INFORMACIÓN PARA GUARDAR' }) }

    }

    createMRPProcessV2 = async () => {
        const { enableSpinner, model, showAlert, saveScnario } = this.props;
        showAlert({ type: 'success', message: 'INICIANDO PREVISIONES' })

        enableSpinner(true)
        let scenarioResponse = await apiClient.crateForecastV2(model);
        enableSpinner(false)


        if (scenarioResponse.status === SERVICE_RESPONSE.SUCCESS) {
            scenarioResponse = scenarioResponse.data;
            await saveScnario(model, scenarioResponse);
            await this.startMRPProcessV2();
        } else {
            showAlert({ type: 'error', message: scenarioResponse.message || 'ERROR' })
        }
    }

    startMRPProcessV2 = async () => {
        const { enableSpinner, model, showAlert } = this.props;
        showAlert({ type: 'success', message: 'INICIANDO RECOMENDACIONES' })

        enableSpinner(true)
        let recomendationsResponse = await apiClient.startScenarioV2(model, model.ForecastArray);
        enableSpinner(false)

        if (recomendationsResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                saveRecommendations: true,
                recommendations: recomendationsResponse?.data?.recommendations ?? [],
                showResultDetails: true
            })
            showAlert({ type: 'success', message: 'GENERANDO PEDIDOS' })
            enableSpinner(true)
            let grpRecomendations = await apiClient.createMRPGroup(this.state.recommendations);
            enableSpinner(false)
            if (grpRecomendations.status === SERVICE_RESPONSE.SUCCESS) {
                this.setState({
                    groupRecomendations: grpRecomendations?.data?.groupedRecommendations ?? [],
                })
                this.sendDocuments();
            } else {
                showAlert({ type: 'error', message: grpRecomendations.message || 'ERROR' })
            }

        } else {
            showAlert({ type: 'error', message: recomendationsResponse.message || 'ERROR' })
        }
    }
    printDocuments = () => {
        this.printRecommendationsDoc();
        this.printFinalDocumentsCreated();

    }
    printFinalDocumentsCreated = () => {
        const date = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        const doc = new jsPDF();

        doc.setFontSize(18);
        doc.text("Reporte de Documentos Creados", 10, 10);
        doc.setFontSize(12);
        doc.text("Generado el: " + moment(new Date()).format("DD/MM/YYYY HH:mm:ss"), 10, 20);


        let startY = 40;
        const pageHeight = doc.internal.pageSize.height;
        const rowHeight = 10;
        doc.setFontSize(12);
        doc.text("Documento", 10, startY);
        doc.text("Almacén", 50, startY);
        doc.text("F. Liberación", 80, startY);
        doc.text("Estado", 120, startY);

        startY += rowHeight;
        
        this.state.documents.forEach((document, index) => {
            if (startY + rowHeight > pageHeight) {
                doc.addPage();
                startY = 10;

                doc.setFontSize(12);
                doc.text("Documento", 10, startY);
                doc.text("Almacén", 50, startY);
                doc.text("F. Liberación", 80, startY);
                doc.text("Estado", 120, startY);

                startY += rowHeight;
            }

            // Agregar los datos
            const docNum = `${document.DocEntry}-${document.DocNum} `
            doc.text(docNum, 10, startY);
            doc.text(document.Warehouse, 50, startY);
            doc.text(moment(document.ReleasDate).format("DD/MM/YYYY").toString(), 80, startY);
            doc.text(document.docCreated ? 'En autorización' : document?.Message ?? 'ERROR', 120, startY);
            
            startY += rowHeight;
        });

        doc.save(`Reporte DOCUMENTOS FINALES MRP ${date}.pdf`);
    }
    printRecommendationsDoc = () => {
        const date = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        const doc = new jsPDF();

        doc.setFontSize(18);
        doc.text("Reporte de Recomendaciones", 10, 10);
        doc.setFontSize(12);
        doc.text("Generado el: " + moment(new Date()).format("DD/MM/YYYY HH:mm:ss"), 10, 20);


        let startY = 40;
        const pageHeight = doc.internal.pageSize.height;
        const rowHeight = 10;
        doc.setFontSize(12);
        doc.text("#", 10, startY);
        doc.text("Tipo Doc.", 25, startY);
        doc.text("Código", 55, startY);
        doc.text("Cantidad", 80, startY);
        doc.text("F. Liberación", 110, startY);
        doc.text("F. Vencimiento", 140, startY);
        doc.text("Almacén", 175, startY);

        startY += rowHeight;
        this.state.recommendations.forEach((line, index) => {
            if (startY + rowHeight > pageHeight) {
                doc.addPage();
                startY = 10;

                doc.setFontSize(12);
                doc.text("#", 10, startY);
                doc.text("Tipo Doc.", 25, startY);
                doc.text("Código", 55, startY);
                doc.text("Cantidad", 80, startY);
                doc.text("F. Liberación", 110, startY);
                doc.text("F. Vencimiento", 140, startY);
                doc.text("Almacén", 175, startY);

                startY += rowHeight;
            }

            // Agregar los datos
            doc.text((index + 1).toString(), 10, startY);
            doc.text(docTypeRecommendation(line.OrderType).toString(), 25, startY);
            doc.text(String(line.ItemCode), 50, startY);
            doc.text(line.Quantity.toString(), 85, startY);
            doc.text(moment(line.ReleasDate).format("DD/MM/YYYY").toString(), 115, startY);
            doc.text(moment(line.DueDate).format("DD/MM/YYYY").toString(), 145, startY);
            doc.text(String(line.Warehouse), 185, startY);

            startY += rowHeight;
        });

        doc.save(`Reporte RECOMENDACIONES MRP ${date}.pdf`);
    }
    sendDocuments = async () => {
        const { enableSpinner, showAlert } = this.props;
        const { groupRecomendations } = this.state
        let contador = 0;
        for (const Warehouse of Object.keys(groupRecomendations)) {
            const dates = groupRecomendations[Warehouse];
            for (const ReleasDate of Object.keys(dates)) {
                const CardCodes = dates[ReleasDate];
                for (const CardCode of Object.keys(CardCodes)) {
                    contador++;
                }

            }

        }
        this.setState({
            totalDocs: contador,
        })
        for (const Warehouse of Object.keys(groupRecomendations)) {
            const dates = groupRecomendations[Warehouse];

            for (const ReleasDate of Object.keys(dates)) {
                const CardCodes = dates[ReleasDate];
                for (const CardCode of Object.keys(CardCodes)) {
                    const items = CardCodes[CardCode];
                    if (!CardCodes.created) {
                        enableSpinner(true)
                        let documentResponse = await apiClient.createMRPDocuments(items, ReleasDate, CardCode);
                        enableSpinner(false)
                        if (documentResponse.status == SERVICE_RESPONSE.SUCCESS) {
                            const auxDocs = this.state.documents.slice();
                            const auxNewDoc = documentResponse?.data?.Document ?? {}
                            auxNewDoc.Warehouse = Warehouse
                            auxDocs.push(auxNewDoc)
                            this.setState({
                                currDoc: this.state.currDoc + 1,
                                documents: auxDocs
                            })
                            CardCodes.created = true;
                        } else {
                            CardCodes.created = false;
                        }
                    }
                }

            }


        }
        if (contador == this.state.currDoc) {
            showAlert({ type: 'success', message: 'Proceso completado con éxtio' })
            this.printDocuments();
        } else {
            showAlert({ type: 'error', message: 'Algunos documentos no se pudieron enviar, intente de nuevo' })
        }
    }
    startScenario = async () => {
        const { documents, recommendations } = this.state
    }
    startScenario = async () => {
        const { enableSpinner, model, showAlert } = this.props
        enableSpinner(true)
        const response = await apiClient.startScenario(model.MsnCode || '')
        enableSpinner(false)
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: response.message || 'ESCENARIO INICIADO' });
            const items = Object.keys(response?.data?.informeFin ?? {});
            let showResultDetails = [];
            for (let i = 0; i < items.length; i++) { showResultDetails.push(false); }

            this.setState({
                saveRecommendations: true,
                recommendations: response?.data?.recommendations ?? [],
                informe: response?.data?.informeFin ?? {},
                showResultDetails,
            })
        } else {
            showAlert({ type: 'error', message: response.message || 'NO SE PUDO INICIAR EL ESCENARIO' })
        }
    }

    validateString = (text) => {
        if (text !== null && text !== '' && text !== undefined) {
            return true
        } else {
            return false
        }
    }

    render() {
        const {
            action,
            model,
            writeAccess,
            forecastList,
        } = this.props;

        const {
            editMode,

            showPredictionsList,
            predictions,
            predictionsAction,

            showForecastModal,
            showWarningModal,
            warningModel,
            recommendations,

            showPeggingModal,
            peggingFilters,
            peggingDocuments
        } = this.state;

        let forecastArray = [];

        if (model.FCTAbs) {
            const forecastSelected = forecastList.find(({ AbsID }) => Number(AbsID) === Number(model.FCTAbs));
            if (!!forecastSelected) { forecastArray.push(forecastSelected.AbsID); }
            else if (!!model.Documents) {
                const docsFiltered = model.Documents.filter(({ DocType }) => Number(DocType) === 198);
                for (const forecast of docsFiltered) {
                    if (forecast.Selected === "Y") { forecastArray.push(forecast.DocEntry); }
                }
            }
        }

        return (
            <div
                id="mrpAssistantModal"
                className="modal fade bd-example-modal-xl modal-open scroll"
                role="dialog"
                data-backdrop="static"
                data-keyboard="false" >
                <div className="modal-dialog modal-xl modal-open modalOrder" role="document">
                    <div className="modal-content" id="modal-content">
                        <div className="modal-header text-white modal-style rounded-0">
                            <h4 className="modal-title" id="modal-basic-title "> Asistente de MRP - {action === 2 && model.MsnCode !== "" ? model.MsnCode : "Nuevo"} </h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true"> &times; </span>
                            </button>
                        </div>
                        <div className="modal-body p-0" >
                            <div className="container-fluid p-0">
                                <div className="pt-3">
                                    <div className="d-none d-lg-flex">
                                        <ul className="nav nav-tabs w-100" id="myTab" role="tablist">

                                            <li className="nav-item ml-3">
                                                <a className="nav-link font-weight-bold text-secondary active" id="HomeMRPV2-tab" data-toggle="tab" href="#HomeMRPV2" role="tab" aria-controls="HomeMRPV2" aria-selected="true"> Escenario </a>
                                            </li>
                                            {/* <li className="nav-item ml-3">
                                                <a className="nav-link font-weight-bold text-secondary active" id="details-tab" data-toggle="tab" href="#details" role="tab" aria-controls="details" aria-selected="true"> Escenario </a>
                                            </li> */}
                                            {/* <li className="nav-item">
                                                <a className="nav-link font-weight-bold text-secondary" id="items-tab" data-toggle="tab" href="#items" role="tab" aria-controls="items" aria-selected="true"> Artículos </a>
                                            </li> */}
                                            {/* <li className="nav-item">
                                                <a className="nav-link font-weight-bold text-secondary" id="warehouses-tab" data-toggle="tab" href="#warehouses" role="tab" aria-controls="warehouses" aria-selected="true"> Inventario </a>
                                            </li> */}
                                            {/* <li className="nav-item">
                                                <a className="nav-link font-weight-bold text-secondary" id="documents-tab" data-toggle="tab" href="#documents" role="tab" aria-controls="documents" aria-selected="true"> Documentos </a>
                                            </li> */}
                                            <li className="nav-item">
                                                <a className="nav-link font-weight-bold text-secondary" id="results-tab" data-toggle="tab" href="#results" role="tab" aria-controls="results" aria-selected="true"> Resultados </a>
                                            </li>

                                            {/* {action === 2 && !editMode && writeAccess &&
                                                <li className="ml-auto mr-2">
                                                    <button className="btn" onClick={this.editMode}>
                                                        <i className="fas fa-edit  fa-lg" /> Editar
                                                    </button>
                                                </li>
                                            } */}
                                        </ul>
                                    </div>
                                    <div className="d-flex d-lg-none">
                                        <ul className="nav nav-tabs w-100" role="tablist">
                                            <li className="nav-item ml-3 dropdown">
                                                <a className="nav-link font-weight-bold text-secondary dropdown-toggle active" data-toggle="dropdown" href="#r" role="button" aria-haspopup="true" aria-expanded="false">Menú</a>
                                                <div className="dropdown-menu p-0">
                                                    {/* <a className="dropdown-item custom-dropdown-item font-weight-bold text-secondary" id="details-tab" data-toggle="tab" href="#details" role="tab" aria-controls="details" aria-selected="true"> Escenario </a> */}
                                                    {/* <a className="dropdown-item custom-dropdown-item font-weight-bold text-secondary" id="items-tab" data-toggle="tab" href="#items" role="tab" aria-controls="items" aria-selected="true"> Artículos </a> */}
                                                    {/* <a className="dropdown-item custom-dropdown-item font-weight-bold text-secondary" id="warehouses-tab" data-toggle="tab" href="#warehouses" role="tab" aria-controls="warehouses" aria-selected="true"> Inventario </a> */}
                                                    {/* <a className="dropdown-item custom-dropdown-item font-weight-bold text-secondary" id="documents-tab" data-toggle="tab" href="#documents" role="tab" aria-controls="documents" aria-selected="true"> Documentos </a> */}
                                                    {/* <div className="dropdown-divider m-0" /> */}
                                                    <a className="dropdown-item custom-dropdown-item font-weight-bold text-secondary" href="#results" role="tab" onClick={(e) => { e.preventDefault(); document.querySelectorAll('.tab-pane').forEach(el => { el.classList.remove('show', 'active'); }); document.getElementById('results').classList.add('show', 'active');}}> Resultados </a>
                                                    <a className="dropdown-item custom-dropdown-item font-weight-bold text-secondary" href="#HomeMRPV2" role="tab" onClick={(e) => { e.preventDefault(); document.querySelectorAll('.tab-pane').forEach(el => { el.classList.remove('show', 'active');  }); document.getElementById('HomeMRPV2').classList.add('show', 'active'); }}> Escenario </a>
                                                </div>
                                            </li>
                                            {/* {action === 2 && !editMode && writeAccess &&
                                                <li className="ml-auto mr-2">
                                                    <button className="btn" onClick={this.editMode}>
                                                        <i className="fas fa-edit  fa-lg" /> Editar
                                                    </button>
                                                </li>
                                            } */}
                                        </ul>
                                    </div>
                                </div>
                                <div className="p-2 p-md-3 m-0 m-md-3">
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="HomeMRPV2" role="tabpanel" aria-labelledby="HomeMRPV2-tab"> {this.renderHomeV2()} </div>
                                        {/* <div className="tab-pane fade show active" id="details" role="tabpanel" aria-labelledby="details-tab"> {this.renderDetails()} </div> */}
                                        {/* <div className="tab-pane fade" id="items" role="tabpanel" aria-labelledby="items-tab"> {this.renderItems()} </div> */}
                                        {/* <div className="tab-pane fade" id="warehouses" role="tabpanel" aria-labelledby="warehouses-tab"> {this.renderWarehouses()} </div> */}
                                        {/* <div className="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab"> {this.renderDocuments()} </div> */}
                                        <div className="tab-pane fade" id="results" role="tabpanel" aria-labelledby="results-tab"> {this.renderResults()} </div>
                                    </div>
                                    {showPredictionsList &&
                                        <SuggestionList
                                            showOptions={showPredictionsList}
                                            predictions={predictions}
                                            onClickAction={predictionsAction}
                                            idList="suggestionList"
                                            className="custom-options"
                                            listClassName="datalist-item"
                                            keyValue="value1" />
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            {action === 1 ?
                                <>
                                    {this.state.totalDocs > 0 && this.state.currDoc === this.state.totalDocs ?
                                        <>
                                            <button className="btn botonCorrect" onClick={this.printDocuments}> Imprimir </button>
                                            <button className="btn botonCerrar text-white" onClick={this.closeModal}> Cerrar </button>
                                        </>
                                        :
                                        <>
                                            <button className="btn botonCorrect" onClick={this.validateModel}> {this.state.currDoc > 0 ? 'Continuar Proceso' : 'Crear'}</button>
                                            <button className="btn botonCerrar text-white" onClick={this.closeModal}> Cancelar </button>
                                        </>}


                                </>
                                :
                                editMode ?
                                    <>
                                        <button className="btn botonCorrect" onClick={this.validateModel}> Guardar </button>
                                        <button className="btn botonCerrar text-white" onClick={this.cancelEditMode}> Cancelar </button>
                                    </>
                                    :
                                    <>
                                        {/*  <button className="btn botonCorrect" onClick={() => this.startMRPProcessV2()}> Iniciar </button>
                                        {!!(recommendations.length) &&
                                            <button className="btn botonCorrect" onClick={() => this.saveRecommendations()}> Guardar Recomendaciones </button>
                                        }*/}
                                        <button className="btn botonCerrar text-white" onClick={this.closeModal}> Cerrar </button>
                                    </>
                            }

                        </div>
                    </div>
                </div>

                {showForecastModal &&
                    <StandardSelectModal
                        disabled={action === 2 && !editMode}
                        id="selectForecastModal"
                        title="Previsiones"
                        data={forecastList}
                        selectAction={(data) => this.selectForecast(data)}
                        selectedItems={forecastArray}

                        headers={[
                            { title: "Previsión", value: true, filter: true, field: "Code", format: null, classes: "text-left" },
                        ]}

                        actPos="start"
                        selection="multiple"
                        idSelection="AbsID"
                        warningQtySelection={50}
                        limitQtySelection={100}
                        validNoSelection={true} />
                }

                {showWarningModal &&
                    <WarningModal
                        title={warningModel.title || "Advertencia"}
                        message={warningModel.message || "¿Seguro que deseas continuar?"}
                        btnAccept={warningModel.acceptMsg || "Continuar"}
                        btnCancel={warningModel.cancelMsg || "Cancelar"}
                        size={warningModel.size || "modal-lg"}
                        accept={warningModel.accept}
                        cancel={warningModel.cancel} />
                }

                {showPeggingModal &&
                    <MRPPeggingModal
                        filters={peggingFilters}
                        docs={peggingDocuments} />
                }
            </div>
        );
    }
    //#endregion
}

export default MRPAssistantModal;